// dynamic components
export const SCREEN = {
  BUNDLE: 'Bundle',
  DETAIL: 'Detail',
  ENTRY: 'Entry',
  ERROR: 'Error',
}

export const BOOLEAN_CONFIG_KEYS = [
  'animatedEntryLabelsOnClick',
  'animatedEntryLabelsOnlyOnce',
  'badge',
  'dynamicSize',
  'logo',
  'openInSameWindow',
  'skipEntryPage',
  'skipPackagesOverview',
  'showPackagesOverviewInfoIcon'
]

export const CATEGORY_ADDITIONAL = 'ADDITIONAL'
export const CATEGORY_FURTHER_ADDITIONAL = 'FURTHER_ADDITIONAL'
